export default {
    newsTitle: 'news_section_title',
    link0: 'news_section_0_text',
    link1: 'news_section_1_text',
    link2: 'news_section_2_text',
    link3: 'news_section_3_text',
    link4: 'news_section_4_text',
};
